// src/components/ui/AuthModal.jsx
import React, { useState } from 'react';

const AuthModal = ({ isOpen, onClose }) => {
  const [activeTab, setActiveTab] = useState('login'); // 'login' or 'signup'

  if (!isOpen) return null;

  const handleSubmit = (e) => {
    e.preventDefault();
    alert(`${activeTab === 'login' ? 'Attempting Log In' : 'Attempting Sign Up'}...`);
    // onClose(); // Uncomment to close modal after submission
  };

  const isLogin = activeTab === 'login';

  return (
    // The 'active' class is critical for the CSS transition
    <div className="auth-modal active" onClick={onClose}>
      <div className="auth-container" onClick={(e) => e.stopPropagation()}>
        <button className="close-modal" onClick={onClose}><i className="fas fa-times"></i></button>
        
        <div className="auth-tabs">
          <button 
            className={`auth-tab ${isLogin ? 'active' : ''}`}
            onClick={() => setActiveTab('login')}
          >
            Log In
          </button>
          <button
            className={`auth-tab ${!isLogin ? 'active' : ''}`}
            onClick={() => setActiveTab('signup')}
          >
            Sign Up
          </button>
        </div>

        <form className="auth-form" onSubmit={handleSubmit}>
          
          <div className="form-group">
            <label htmlFor="modal-email">Email Address</label>
            <input type="email" id="modal-email" required />
          </div>

          <div className="form-group">
            <label htmlFor="modal-password">Password</label>
            <input type="password" id="modal-password" required />
          </div>

          {!isLogin && (
             <div className="form-group">
                <label htmlFor="modal-referral">Referral Code (Optional)</label>
                <input type="text" id="modal-referral" placeholder="Enter code or username" />
             </div>
          )}

          <div className="form-options">
            <label className="remember-me">
              <input type="checkbox" />
              Remember Me
            </label>
            <a href="#" className="forgot-password">Forgot Password?</a>
          </div>

          <button type="submit" className="auth-submit">
            {isLogin ? 'Log In to Kinetix' : 'Create Account'}
          </button>
          
          <div className="auth-divider">OR</div>

          <div className="social-auth">
            <button className="social-btn" type="button">
              <i className="fab fa-google"></i> Google
            </button>
            <button className="social-btn" type="button">
              <i className="fab fa-discord"></i> Discord
            </button>
          </div>

          <div className="auth-switch">
            {isLogin ? "Don't have an account? " : "Already have an account? "}
            <a href="#" onClick={(e) => {e.preventDefault(); setActiveTab(isLogin ? 'signup' : 'login');}}>
              {isLogin ? 'Sign Up' : 'Log In'}
            </a>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AuthModal;